import axios from '../axios-on-rails';

class CandidateNotes {

  setMemberID() {
    var checked_members = $('.js-cid:checkbox:checked');
    // console.log("setMemberID - checked_members: " + checked_members);
    if (checked_members.length == 0) {
      return [];
    }

    var ary_member_id = [];
    var ary_cand_note_id = [];
    checked_members.each(function(index) {
      ary_member_id.push($(this).attr('data-member-id'));
      ary_cand_note_id.push($(this).prop('value'));
    });
    $('#candidate_note_ids').val(ary_cand_note_id);
    return ary_member_id;
  }

  submitMultiDelete(element) {
    console.log("this.setMemberID: " + this.setMemberID());
    if (this.setMemberID().length == 0) {
      alert($(element).attr('message'));
      return false;
    }
    this.removeCookie();
    return true;
  }

  submitMultiMessage(element, event) {
    let $this = this;
    var ary_member_id = this.setMemberID();
    if (ary_member_id.length == 0) {
      alert($(element).attr('message'));
      return false;
    }
    // console.log("ary_member_id " + ary_member_id);
    $.ajax({
      async: false,
      method: 'post',
      url: Routes.members_status_candidatenotes_multimessage_index_path(gon.locale),
      data: { member_ids: ary_member_id },
      success: function (res) {
        $.each (res.members_status, function(index, status) {
          // console.log(status);
          if (status[1] == false) {
            event.preventDefault();
            alert(res.resume_hidden_pre + status[0] + res.resume_hidden);
            return false;
          }
        });
        $this.removeCookie();
        return true;
      },
      fail: function(err) {
        console.log(err);
      }
    })
  }

  checkAll(element) {
    var checked = $(element).prop('checked');
    $('.js-cid').prop('checked', checked);
  }


  setValue(element) {
    // TODO control 'all' checkbox like scout history
    return true;
  }

  hiddenWords() {
    if($('#keyword_like').val() == ''){
      document.getElementById('keyword').value='';
      document.getElementById('keyword').style.color = 'black';
    }else{
      document.getElementById('keyword').style.color = 'black';
    }
  }

  removeCookie() {
    Cookies.remove(`dj_candidate_note_${gon.current_company_user.id}`);
  }
}

export default new CandidateNotes();
